import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { CustomDialogComponent } from './custom-dialog/custom-dialog.component';
import { GoToTopComponent } from './go-to-top/go-to-top.component';
import { MyCartComponent } from './my-cart/my-cart.component';
import { AddToCartComponent } from './add-to-cart/add-to-cart.component';
import { RestockOptionSelectComponent } from './restock-option-select/restock-option-select.component';
import { RestockModeSelectComponent } from './restock-mode-select/restock-mode-select.component';
import { TermsPolicyAgreementDialogComponent } from './terms-policy-agreement-dialog/terms-policy-agreement-dialog.component';

const COMPONENTS = [
  CustomDialogComponent,
  GoToTopComponent,
  MyCartComponent,
  AddToCartComponent,
  RestockOptionSelectComponent,
  RestockModeSelectComponent,
  TermsPolicyAgreementDialogComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, RouterModule, SharedModule],
  // entryComponents: [CustomDialogComponent],
  exports: [...COMPONENTS],
})
export class RespComponentModule {}
